import React from 'react'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'


import useStateObject from '~/client/hooks/useStateObject'
import { useQuery, useCommand } from '~/client/hooks/cqrpc'
import Link from '~/client/components/Link'
import Form from '~/client/components/Form'
import FormButtonRow from '~/client/components/FormButtonRow'
import ErrorMessage from '~/client/components/ErrorMessage'
import DocumentTypeInput from '~/client/components/DocumentTypeInput'
import JSONSchemaFormInput from '~/client/components/JSONSchemaFormInput'
import InspectObject from '~/client/components/InspectObject'

export default function DataCreateForm({
  disabled = false,
  documentTypeId,
  onSuccess,
  onFailure,
  onComplete,
  submitText = 'Create',
  submittingText = 'Creating…',
}){
  const create = useCommand('documents.create', {
    onSuccess, onFailure, onComplete,
  })

  const [doc, onChange] = useStateObject({
    name: '',
    value: undefined,
  })

  const getType = useQuery(
    documentTypeId ? 'documentTypes.getById' : null,
    { id: documentTypeId }
  )
  const documentType = getType.result

  const submittable = !!(documentType)
  return <Form {...{
    disabled,
    onSubmit(){
      const typeId = documentTypeId
      const { name, value } = doc
      create.call({ typeId, name, value })
    }
  }}>
    <TextField
      required
      variant="standard"
      autoFocus
      label="Document Name"
      margin="normal"
      fullWidth
      type="text"
      value={doc.name}
      onChange={e => { onChange({ name: e.target.value }) }}
    />
        <ErrorMessage error={create.error}/>
    {documentType?.schema
      ? <JSONSchemaFormInput {...{
        disabled,
        schema: documentType?.schema,
        uiSchema: documentType?.uiSchema || undefined,
        value: doc.value,
        onChange(value){ onChange({ value }) },
      }}/>
      : null
    }
    <FormButtonRow {...{
      disabled,
      submittable,
      submitting: create.pending,
      submitText,
      submittingText,
    }}/>
    {/*<InspectObject object={{documentType, doc}}/>*/}
  </Form>
}
